export const books = [
    {
        id: 1,
        title:"Fire & Blood",
        author: "george r. r. martin",
        price: 200.99,
        updatePrice: 159.99,
        offerPrice: 120.00,
        img: "https://m.media-amazon.com/images/I/41gq02g-MoL.jpg",
        img2:"",
        Img3:"",
        stock: "In Stock",
        ProductCode:"gm11",
        Publisher:"Bantam Spectra (US) Voyager Books (UK)",
        publishedYear:"1991",
        pages:"1184",
        description:"A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",
        
        
    },
    {
        id: 2,
        title: "A game of thrones",
        author: "george r. r. martin",
        price: 200.99,
        updatePrice: 150.00,
        img: "https://m.media-amazon.com/images/I/611uO6Neh1L._SY264_BO1,204,203,200_QL40_ML2_.jpg",
        img2: "",
        Img3: "",
        stock: "In Stock",
        ProductCode: "gm22",
        Publisher: "Bantam Spectra (US) Voyager Books (UK)",
        publishedYear: "1996",
        pages: "694",
        description: "A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",

    },
    {
        id: 3,
        title: "A clash of kings",
        author: "george r. r. martin",
        price: 300.00,
        updatePrice: 266.99,
        img: "https://images3.penguinrandomhouse.com/cover/9781984821157",
        img2: "",
        Img3: "",
        stock: "In Stock",
        ProductCode: "gm33",
        Publisher: "Bantam Spectra (US) Voyager Books (UK)",
        publishedYear: "1999",
        pages: "768",
        description: "A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",

    },
    {
        id: 4,
        title: "a dream of spring",
        author: "george r. r. martin",
        price: 165.99,
        updatePrice: 125.99,
        img: "https://cdn.thestorygraph.com/h56q0c2gv9ahyrqj0qg9aof6f2zq",
        img2: "",
        Img3: "",
        stock: "Upcomming",
        ProductCode: "gm44",
        Publisher: "Bantam Spectra (US) Voyager Books (UK)",
        publishedYear: "not Published Yet",
        pages: "N/A",
        description: "A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",

    },
    {
        id: 5,
        title: "a dance with dragon",
        author: "george r. r. martin",
        price: 100.00,
        updatePrice: 89.99,
        img: "https://m.media-amazon.com/images/I/51wvwelggiL._SX324_BO1,204,203,200_.jpg",
        img2: "",
        Img3: "",
        stock: "In Stock",
        ProductCode: "gm55",
        Publisher: "Bantam Spectra (US) Voyager Books (UK)",
        publishedYear: "2011",
        pages: "1056",
        description: "A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",

    },
    {
        id: 6,
        title: "a feast of crows",
        author: "george r. r. martin",
        price: 120.00,
        updatePrice: 100.00,
        img: "https://m.media-amazon.com/images/I/51T6kUoKSWL._SY346_.jpg",
        img2: "",
        Img3: "",
        stock: "In Stock",
        ProductCode: "gm66",
        Publisher: "Bantam Spectra (US) Voyager Books (UK)",
        publishedYear: "2005",
        pages: "753",
        description: "A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",

    },
    {
        id: 7,
        title: "a storm of swords",
        author: "george r. r. martin",
        price: 120.00,
        updatePrice: 100.00,
        img: "https://images.penguinrandomhouse.com/cover/9780593158951",
        img2: "",
        Img3: "",
        stock: "In Stock",
        ProductCode: "gm77",
        Publisher: "Bantam Spectra (US) Voyager Books (UK)",
        publishedYear: "2000",
        pages: "973",
        description: "A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",

    },
    {
        id: 8,
        title: "the wind of winter",
        author: "george r. r. martin",
        price: 120.00,
        updatePrice: 100.00,
        img: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1465341854l/12111823._SY475_.jpg",
        img2: "",
        Img3: "",
        stock: "Upcomming",
        ProductCode: "gm77",
        Publisher: "Bantam Spectra (US) Voyager Books (UK)",
        publishedYear: "Not Published Yet",
        pages: "N/A",
        description: "A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",

    },
    {
        id: 9,
        title: "the wind of winter",
        author: "george r. r. martin",
        price: 120.00,
        updatePrice: 100.00,
        img: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1465341854l/12111823._SY475_.jpg",
        img2: "",
        Img3: "",
        stock: "Upcomming",
        ProductCode: "gm77",
        Publisher: "Bantam Spectra (US) Voyager Books (UK)",
        publishedYear: "Not Published Yet",
        pages: "N/A",
        description: "A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",

    },

    {
        id: 10,
        title: "the wind of winter",
        author: "george r. r. martin",
        price: 120.00,
        updatePrice: 100.00,
        img: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1465341854l/12111823._SY475_.jpg",
        img2: "",
        Img3: "",
        stock: "Upcomming",
        ProductCode: "gm77",
        Publisher: "Bantam Spectra (US) Voyager Books (UK)",
        publishedYear: "Not Published Yet",
        pages: "N/A",
        description: "A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",

    },


    {
        id: 11,
        title: "the wind of winter",
        author: "george r. r. martin",
        price: 120.00,
        updatePrice: 100.00,
        img: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1465341854l/12111823._SY475_.jpg",
        img2: "",
        Img3: "",
        stock: "Upcomming",
        ProductCode: "gm77",
        Publisher: "Bantam Spectra (US) Voyager Books (UK)",
        publishedYear: "Not Published Yet",
        pages: "N/A",
        description: "A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",

    },

    {
        id: 12,
        title: "the wind of winter",
        author: "george r. r. martin",
        price: 120.00,
        updatePrice: 100.00,
        img: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1465341854l/12111823._SY475_.jpg",
        img2: "",
        Img3: "",
        stock: "Upcomming",
        ProductCode: "gm77",
        Publisher: "Bantam Spectra (US) Voyager Books (UK)",
        publishedYear: "Not Published Yet",
        pages: "N/A",
        description: "A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",

    },

    {
        id: 13,
        title: "the wind of winter",
        author: "george r. r. martin",
        price: 120.00,
        updatePrice: 100.00,
        img: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1465341854l/12111823._SY475_.jpg",
        img2: "",
        Img3: "",
        stock: "Upcomming",
        ProductCode: "gm77",
        Publisher: "Bantam Spectra (US) Voyager Books (UK)",
        publishedYear: "Not Published Yet",
        pages: "N/A",
        description: "A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",

    },

    {
        id: 14,
        title: "the wind of winter",
        author: "george r. r. martin",
        price: 120.00,
        updatePrice: 100.00,
        img: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1465341854l/12111823._SY475_.jpg",
        img2: "",
        Img3: "",
        stock: "Upcomming",
        ProductCode: "gm77",
        Publisher: "Bantam Spectra (US) Voyager Books (UK)",
        publishedYear: "Not Published Yet",
        pages: "N/A",
        description: "A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",

    },

    {
        id: 15,
        title: "the wind of winter",
        author: "george r. r. martin",
        price: 120.00,
        updatePrice: 100.00,
        img: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1465341854l/12111823._SY475_.jpg",
        img2: "",
        Img3: "",
        stock: "Upcomming",
        ProductCode: "gm77",
        Publisher: "Bantam Spectra (US) Voyager Books (UK)",
        publishedYear: "Not Published Yet",
        pages: "N/A",
        description: "A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",

    },

    {
        id: 16,
        title: "the wind of winter",
        author: "george r. r. martin",
        price: 120.00,
        updatePrice: 100.00,
        img: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1465341854l/12111823._SY475_.jpg",
        img2: "",
        Img3: "",
        stock: "Upcomming",
        ProductCode: "gm77",
        Publisher: "Bantam Spectra (US) Voyager Books (UK)",
        publishedYear: "Not Published Yet",
        pages: "N/A",
        description: "A Game of Thrones is the first novel in A Song of Ice and Fire, a series of fantasy novels by American author George R. R. Martin.",

    },
    
];



export const blogs = [
    {
        id: 1,
        title: "Technology 2k22",
        img: "https://cdn.pixabay.com/photo/2019/01/17/23/14/work-3938876_960_720.jpg",
        decription:"Suppablog is, hence the name, a super blog template. It is minimal, yet features a well-crafted design that will help your blog to stand out from the crowd.",
    },
    {
        id: 2,
        title: "Photography and passion",
        img: "https://cdn.pixabay.com/photo/2015/05/31/10/55/man-791049_960_720.jpg",
        decription: "Suppablog is, hence the name, a super blog template. It is minimal, yet features a well-crafted design that will help your blog to stand out from the crowd.",

    },
    {
        id: 3,
        title: "Global Warming",
        img: "https://cdn.pixabay.com/photo/2015/05/11/14/44/pencils-762555_960_720.jpg",
        decription: "Suppablog is, hence the name, a super blog template. It is minimal, yet features a well-crafted design that will help your blog to stand out from the crowd.",

    },
    {
        id: 4,
        title: "Life with trauma",
        img: "https://cdn.pixabay.com/photo/2017/04/05/01/16/food-2203732_960_720.jpg",
        decription: "Suppablog is, hence the name, a super blog template. It is minimal, yet features a well-crafted design that will help your blog to stand out from the crowd.",

    },
    {
        id: 5,
        title: " Is working from home good?",
        img: "https://cdn.pixabay.com/photo/2020/03/06/08/00/laptop-4906312_960_720.jpg",
        decription: "Suppablog is, hence the name, a super blog template. It is minimal, yet features a well-crafted design that will help your blog to stand out from the crowd.",

    },
    {
        id: 6,
        title: "Earning vs Working Pressure",
        img: "https://cdn.pixabay.com/photo/2019/01/17/23/14/work-3938876_960_720.jpg",
        decription: "Suppablog is, hence the name, a super blog template. It is minimal, yet features a well-crafted design that will help your blog to stand out from the crowd.",

    },

];


export const branches = [
    {
        id: 1,
        title: "Dhaka",

    },
    {
        id: 2,
        title: "Rajshahi",

    },
    {
        id: 3,
        title: "Khulna",

    },
    {
        id: 4,
        title: "Mymensingh",

    },
    {
        id: 5,
        title: "Sylhet",

    },
    {
        id: 6,
        title: "Barishal",

    },
    {
        id: 7,
        title: "Chattogram",

    },
    {
        id: 8,
        title: "Rangpur",

    },
];